/* eslint-disable no-empty-function */

export const restDefault = {
  isLoading: false,
  isError: false,
  error: undefined,
  refetch: (): void => {},
};

export const responsePaginationDefault = {
  limit: 10,
  currentPage: 1,
  offset: 0,
  startIndex: 0,
  endIndex: 0,
  totalPages: 1,
  totalResult: 1,
  handleNextClick: (): void => {},
  handlePreviousClick: (): void => {},
  handlePageUpdate: (): void => {},
  handleLimitUpdate: (): void => {},
  handleOffsetUpdate: (): void => {},
  hasPreviousPage: false,
  hasNextPage: false,
};

export const defaultPaginationMeta = {
  limit: 10,
  offset: 0,
  currentPage: 1,
  totalPages: 1,
  totalResult: 1,
};

export const driveTypes = {
  PROJECT: "PROJECT",
  PROJECT_REGISTER: "PROJECT_REGISTER",
  TASK_AND_CLAIMS: "TASK_AND_CLAIMS",
  PROJECT_REGISTER_ARCHIVE: "projectRegisterArchive",
  PROJECT_ARCHIVE: "projectArchive",
  TASK_AND_CLAIMS_ARCHIVE: "taskAndClaimsArchive",
};
